import { Controller } from '@hotwired/stimulus'
import { application } from './application'

let asyncControllerLoaded = false

export default class extends Controller {
  events = []

  connect () {
    if (!asyncControllerLoaded) {
      asyncControllerLoaded = true
      import('./prospection_controller_async').then((controller) => {
        application.load([{ identifier: 'prospection', controllerConstructor: controller.default }])
        setTimeout(() => {
          this.events.forEach(event => {
            window.dispatchEvent(event)
          })
        }, 100)
      })
    }
  }

  moveToSearch () {
  }

  moveToCoordinates (event) {
    this.events.push(event)
  }

  displayMarkers (event) {
    this.events.push(event)
  }

  updateSearchRadius (event) {
    this.events.push(event)
  }
}
